import { render, staticRenderFns } from "./commodityFlowAdjustmentComponent.vue?vue&type=template&id=7c9f9812&scoped=true&"
import script from "./commodityFlowAdjustmentComponent.vue?vue&type=script&lang=js&"
export * from "./commodityFlowAdjustmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./commodityFlowAdjustmentComponent.vue?vue&type=style&index=0&id=7c9f9812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f9812",
  null
  
)

export default component.exports